<template>
  <LcInfoButton
    :key="`infobutton_${locale}`"
    :headline="title"
    :open-button-aria-label="title"
    :text="$t(`${base}.text`)"
    @click.stop.prevent
  />
</template>

<script lang="ts" setup>
type MyOrdersStatusInfoButtonProps = { status: string; type: string }

const props = defineProps<MyOrdersStatusInfoButtonProps>()

const { locale, t } = useI18n()

const base = computed(() => `myorders.status.${props.type}.${props.status}.info`)
const title = computed(() => t(`${base.value}.title`))
</script>
